import lazyWithPreload from 'utils/lazyPreload';

const SurveyDrawer = lazyWithPreload(() => import('./components/SurveyDrawer'));
const RemoveLogicModal = lazyWithPreload(
  () =>
    import(
      './components/SurveyDrawer/components/SurveyOutline/components/SurveyEditor/components/RemoveLogicModal'
    ),
);
const BulkAddModal = lazyWithPreload(
  () =>
    import(
      'modules/Surveys/components/SurveyDrawer/components/EditTab/components/QuestionType/components/BulkAddModal'
    ),
);

export default {
  SURVEY_DRAWER: SurveyDrawer,
  REMOVE_LOGIC_MODAL: RemoveLogicModal,
  BULK_ADD_MODAL: BulkAddModal,
};
